import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";

const BELIEFS = [
  "“If I have VA eligibility, zero down means I will need no cash for the transaction.”",
  "“If I used VA financing before, I cannot use the benefit again.”",
  "“Sellers will not consider an offer that uses VA financing.”",
];

/* SECTION 4 — PERSONAL LETTER / FALSE BELIEFS */
export const Letter = () => (
  <section className="relative overflow-hidden px-5 md:px-10 lg:px-16 py-28 md:py-36 hairline-t" data-testid="letter-section">
    <div
      aria-hidden="true"
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url(/assets/bg-home-1.jpg)" }}
    />
    <div
      aria-hidden="true"
      className="absolute inset-0"
      style={{ background: "linear-gradient(180deg, rgba(0,0,99,0.95), rgba(0,0,99,0.88), rgba(0,0,99,0.95))" }}
    />
    <SectionParticles variant="keys" />
    <div className="relative z-10 max-w-5xl mx-auto text-left">
      <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-12">
        [002] — WHAT GETS IN THE WAY
      </p>
      <Reveal>
        <p className="font-display italic text-2xl md:text-3xl text-white mb-12">Florida VA Homebuyer,</p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-14">
        {BELIEFS.map((b, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div
              data-testid={`false-belief-card-${i}`}
              className="h-full rounded-[6px] border border-[rgba(255,90,90,0.22)] p-6"
              style={{ background: "var(--danger-soft)" }}
            >
              <span aria-hidden="true" className="block font-mono text-lg text-[rgba(255,120,120,0.75)] mb-4">✕</span>
              <p className="text-sm md:text-base leading-relaxed text-[rgba(255,255,255,0.82)]">{b}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div aria-hidden="true" className="w-24 h-[2px] bg-[var(--accent)] mb-12" />

      <Reveal>
        <div className="space-y-6 text-base md:text-lg leading-relaxed text-[rgba(255,255,255,0.78)] max-w-3xl">
          <p>
            Here is what usually sits behind that first belief. VA financing may permit no down payment for an
            eligible borrower who qualifies—but the down payment is only one category of funds in a purchase.
            Deposits, inspections, the appraisal, closing costs, prepaid items, reserves, and other funds can
            still be relevant to a transaction. Understanding those categories before you shop is very
            different from assuming they do not exist.
          </p>
          <p>
            The second belief confuses one question with another. Having used VA financing before does not, by
            itself, answer the question of remaining entitlement. Eligibility and entitlement are specific,
            verifiable items—and verification, not memory or a forum thread, is what settles them.
          </p>
          <p>
            And the third belief hands a seller's decision to a rumor. Offer acceptance is always the seller's
            decision, and it depends on the full transaction in front of them. What a buyer can control is
            preparation and coordination—how the offer is assembled, documented, and communicated. That is a
            skill this workshop teaches. It is not a promise of acceptance, because no honest educator can make
            one.
          </p>
          <p>
            The workshop exists to replace compressed headlines with organized questions, so your next move is
            chosen—not guessed.
          </p>
        </div>
      </Reveal>

      <Reveal>
        <p className="font-mono text-sm tracking-[0.08em] text-[var(--accent)] mt-12">
          — Chaunci Witherspoon, MBA · Kinsfolk Mortgage
        </p>
      </Reveal>
    </div>
  </section>
);
